// extracted by mini-css-extract-plugin
export default {"container":"XR0KJfjA","wrapper":"m9yqirKi","slide":"L7grCwXB"};